import React from 'react';
import { useSingleEffect } from 'react-haiku';

import { Title } from 'components/Misc/Typography';

import Webinars from 'containers/Teacher/Home/Webinars';
import Takes from 'containers/Teacher/Home/Takes';
import Articles from 'containers/Teacher/Home/Articles';

import { useAppStore } from 'store/useAppStore';

const Home = () => {
	// Use app's store
	const setSection = useAppStore(state => state.setSection);

	// Set section on mount
	useSingleEffect(() => setSection('/'));

	return (
		<div className="space-y-4">
			<Title
				title="Sākums"
				className="text-2xl"
			/>

			<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
				{/* Closest teacher's webinar collection */}
				<Webinars />

				{/* Recent finished takes */}
				<Takes />
			</div>

			<Articles />
		</div>
	);
};

export default Home;
